<template lang="pug">
div.platform-stats
  .fs-16.text-white-on-dark.pb-5
    b Pool Stats
  .stats-item
    div(:class="{'animate': totalChanged}")
      .c-1.indicator.hint--bottom(aria-label='Paid across all assets')
      span.amount {{ totalPaid | thousandComma }} 
      span BTC paid to miners
    div(:class="{'animate': totalChanged}")
      .c-2.indicator.hint--bottom(aria-label='Paid across all assets')
      span.amount {{ totalWorkers | thousandComma }} 
      span Past 24hr active workers
    div(:class="{'animate': totalChanged}")
      .c-3.indicator.hint--bottom(aria-label='Paid across all assets')
      span.amount {{ totalMiners | thousandComma }} 
      span Past 24hr active miners

</template>

<script>
export default {
  name: 'c_platform_stats',
  data: () => ({
  }),
  computed: {
    totalWorkers() {
      return this.$store.getters.totalWorkers
    },
    totalPaid() {
      return this.$store.getters.totalPaid
    },
    totalMiners() {
      return this.$store.getters.totalMiners
    },
    totalChanged() {
      return this.$store.getters.totalChanged
    }
  }
}
</script>

<style lang="stylus" scoped>
.platform-stats {
  padding: 1.5rem 0.5rem 0rem 0.5rem;
  text-align: left;
}

.stats-item
  margin-top 15px
  padding-left 15px
  font-size 14px

.amount
  font-weight 800
.indicator
  display: inline-block
  width 10px
  height 10px
  background #97f5e0
  border-radius: 50%
  vertical-align: middle
  margin-left 4px;
  cursor pointer
  margin-right 8px
  &.c-1
    background #ffed6c  
  &.c-2
    background #98F4E4
  &.c-3
    background #6CC9FF

html.dark, body.dark
  .stats-item
    color: #fff
</style>



// WEBPACK FOOTER //
// c_platform_stats.vue?fc265560